import ConfirmSearchItemStep from '../components/tabs-content/pages/confirm-search-item';
import SelectDataSourceStep from '../components/tabs-content/pages/select-data-source';
import SelectReportStep from '../components/tabs-content/pages/select-report';
import ConfirmationStep from '../components/tabs-content/pages/confirmation';
import Results from '../components/tabs-content/pages/results';

const steps = [
    {
        title: 'Confirm Search Item',
        stepUniqueKey: 'search-item',
        component: (props) => <ConfirmSearchItemStep {...props} />
    },
    {
        title: 'Select Data Source',
        stepUniqueKey: 'select-data-source',
        component: (props) => <SelectDataSourceStep {...props} />
    },
    {
        title: 'Select Report',
        stepUniqueKey: 'select-report',
        component: (props) => <SelectReportStep {...props} />
    },
    {
        title: ({ t }) => {
            return t('Confirm {{creditLabel}} Usage', {
                creditLabel: 'Credit'
            })
        },
        stepUniqueKey: 'confirmation',
        component: (props) => <ConfirmationStep {...props} />
    },
    {
        title: 'Results',
        stepUniqueKey: 'results',
        component: (props) => <Results {...props} />
    }
];

export {
    steps
}